export const AUTH_USER = 'auth_user';
export const SET_ERR_MSG = 'set_err_msg';
export const RESET_ERR_MSG = 'reset_err_msg';

export const UNAUTH_USER = 'unauth_user';

export const PERFORMANCE_PAGE_API_REQUEST = 'performance_page_api_request';
export const PERFORMANCE_PAGE_API_SUCCESS = 'performance_page_api_success';
export const PERFORMANCE_PAGE_API_ERROR = 'performance_page_api_error';

export const ADJUSTMENT_PAGE_API_REQUEST = 'adjustment_page_api_request';
export const ADJUSTMENT_PAGE_API_SUCCESS = 'adjustment_page_api_success';
export const ADJUSTMENT_PAGE_API_ERROR = 'adjustment_page_api_error';

export const PREDICTION_PAGE_API_REQUEST = 'prediction_page_api_request';
export const PREDICTION_PAGE_API_SUCCESS = 'prediction_page_api_success';
export const PREDICTION_PAGE_API_ERROR = 'prediction_page_api_error';

export const SYMBOL_SUMMARY_PAGE_API_REQUEST = 'SYMBOL_SUMMARY_page_api_request';
export const SYMBOL_SUMMARY_PAGE_API_SUCCESS = 'SYMBOL_SUMMARY_page_api_success';
export const SYMBOL_SUMMARY_PAGE_API_ERROR = 'SYMBOL_SUMMARY_page_api_error';

export const SYMBOL_SUMMARY_SYMBOL_DETAIL_REQUEST = 'SYMBOL_SUMMARY_SYMBOL_DETAIL_request';
export const SYMBOL_SUMMARY_SYMBOL_DETAIL_SUCCESS = 'SYMBOL_SUMMARY_SYMBOL_DETAIL_success';
export const SYMBOL_SUMMARY_SYMBOL_DETAIL_ERROR = 'SYMBOL_SUMMARY_SYMBOL_DETAIL_error';

export const USER_LOGIN_API_ERROR = 'USER_LOGIN_API_ERROR';
export const USER_LOGIN_API_REQUEST = 'USER_LOGIN_API_REQUEST';
export const USER_LOGIN_API_SUCCESS = 'USER_LOGIN_API_SUCCESS';

export const DATE_LIST_API_ERROR = 'DATE_LIST_API_ERROR';
export const DATE_LIST_API_SUCCESS = 'DATE_LIST_API_SUCCESS';
export const DATE_LIST_API_REQUEST = 'DATE_LIST_API_REQUEST';



// WEBPACK FOOTER //
// ./src/constant/actionTypes.js